import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './linh-vuc.reducer';

export const LinhVucDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const linhVucEntity = useAppSelector(state => state.linhVuc.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="linhVucDetailsHeading">
          <Translate contentKey="xtdtApp.linhVuc.detail.title">LinhVuc</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{linhVucEntity.id}</dd>
          <dt>
            <span id="ten">
              <Translate contentKey="xtdtApp.linhVuc.ten">Ten</Translate>
            </span>
          </dt>
          <dd>{linhVucEntity.ten}</dd>
          <dt>
            <span id="iconDaiDien">
              <Translate contentKey="xtdtApp.linhVuc.iconDaiDien">Icon Dai Dien</Translate>
            </span>
          </dt>
          <dd>{linhVucEntity.iconDaiDien}</dd>
        </dl>
        <Button tag={Link} to="/linh-vuc" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/linh-vuc/${linhVucEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default LinhVucDetail;
